module.exports = __webpack_public_path__ + "static/media/mentions_legales_olassist.3c6b4bc5.pdf";